import html2canvas from "html2canvas";

function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

/**
 * Captura el contenedor de la gráfica del historial (Recharts) como PNG.
 * @param {React.RefObject<HTMLElement|null>} chartRef
 * @returns {Promise<string|null>} data URL o null si no hay ref / falla la captura
 */
export async function captureHistoryChartPng(chartRef) {
  const el = chartRef?.current;
  if (!el || !el.isConnected) return null;

  el.scrollIntoView({ block: "nearest", behavior: "instant" });
  await new Promise((r) => requestAnimationFrame(r));
  await new Promise((r) => requestAnimationFrame(r));
  await sleep(550);

  try {
    const canvas = await html2canvas(el, {
      scale: Math.min(2, window.devicePixelRatio || 2),
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
      scrollX: 0,
      scrollY: -window.scrollY,
      windowWidth: el.scrollWidth,
      windowHeight: el.scrollHeight,
    });
    return canvas.toDataURL("image/png", 1.0);
  } catch {
    return null;
  }
}

/**
 * Exporta PDF del historial (tabla + estadísticas en servidor; gráfica como imagen opcional).
 */
export async function exportQuickStatsHistoryPdf({
  api,
  cellId,
  dateFrom,
  dateTo,
  chartRef,
  hasChartData,
  chartBusy = false,
  onError,
}) {
  let chart_image_base64 = null;
  if (hasChartData && !chartBusy) {
    chart_image_base64 = await captureHistoryChartPng(chartRef);
  }

  try {
    const res = await api.post(
      "/cell-quick-weekly-stats/history/export/pdf",
      {
        cell_id: cellId,
        date_from: dateFrom,
        date_to: dateTo,
        chart_image_base64,
      },
      { responseType: "blob", timeout: 180_000 }
    );
    const mime = res.headers["content-type"] || "application/pdf";
    const blob = new Blob([res.data], { type: mime });
    const cd = res.headers["content-disposition"] || "";
    const m = /filename="?([^";]+)"?/i.exec(cd);
    const fallback = `historial_celulas_${dateFrom}_${dateTo}.pdf`;
    const filename = (m && m[1] ? m[1].trim() : null) || fallback;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    let mapped = err;
    if (err.response?.data instanceof Blob) {
      try {
        const t = await err.response.data.text();
        const j = JSON.parse(t);
        mapped = { ...err, response: { ...err.response, data: j } };
      } catch {
        /* keep original err */
      }
    }
    onError?.(mapped);
    throw mapped;
  }
}
